var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-timeline',[_c('v-timeline-item',[_vm._v("timeline item")]),_c('v-timeline-item',{staticClass:"text-right"},[_vm._v("timeline item")]),_c('v-timeline-item',[_vm._v("timeline item")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }